define("powergen/routes/system",
  [],
  function() {
    "use strict";
    var SystemRoute;

    SystemRoute = Ember.Route.extend({
      model: function(params) {
        return this.get('store').find('game', 'main').then(function(game) {
          return game.get('systems').findProperty('id', params.system_id);
        });
      },
      setupController: function(controller, model) {
        controller.reset();
        return controller.set('model', model);
      }
    });


    return SystemRoute;
  });